import React, { useState } from 'react';

import { Tooltip } from '~/eds/src/components/Tooltip/Tooltip';
import { useIntl } from 'react-intl';

import Text from '../components/Text/Text';

export function useShowMoreItems({
  items,
  limit: initialLimit,
  step = items.length,
  mapItemText,
}) {
  const intl = useIntl();
  const [limit, setLimit] = useState(initialLimit);
  const visibleItems = items.slice(0, limit);
  const hiddenItems = items.slice(limit);
  const hiddenItemsTooltip = hiddenItems
    .map((item) => mapItemText(item, intl))
    .join('\n');

  const handleShowMore = () => {
    setLimit(limit + step);
  };

  const showMore = hiddenItems.length > 0 && (
    <Tooltip tooltip={hiddenItemsTooltip}>
      <Text variant="2xs-dense" onClick={handleShowMore}>
        {intl.formatMessage(
          {
            id: 'UseShowMoreItems.showMoreItems',
            defaultMessage: '+{count} more',
            description: 'Button to show more items. Example: count = "3"',
          },
          { count: hiddenItems.length },
        )}
      </Text>
    </Tooltip>
  );

  return [visibleItems, showMore];
}
